import { UserModel } from '@/core/models/user.model';
import { StateService } from '@/core/services/state.service';
import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Align } from '@progress/kendo-angular-popup';
import { ExtendedAuthenticationService } from '../../components/authentication/services/extended-authentication.service';
import { I18nService } from '@/core/services/i18nService';
import { TranslateService } from '@ngx-translate/core';
import { UntypedFormControl } from '@angular/forms';
import { GlobalEnumsAcePortalsprache, GlobalEnumsAcePortaltyp, PortalkonfigurationDisplayModel } from '@/api/model-index';
import { environment } from 'src/environments/environment';
import { Constants } from '@/constants';
import { StammdatenService } from '@/core/services/stammdaten.service';

@Component({
  selector: 'core-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Input('showUsername') public showUsername: boolean = true;
  @Input('showLinks') public showLinks: boolean = true;
  @Input('showChat') public showChat: boolean = true;

  protected user: UserModel;
  public anchorAlign: Align = { horizontal: "right", vertical: "bottom" };
  public popupAlign: Align = { horizontal: "right", vertical: "top" };
  public show = false;
  public portalkonfiguration: PortalkonfigurationDisplayModel;
  public langsObject: any[] = [];
  public languageFormControl: UntypedFormControl = new UntypedFormControl();
  
  public brandLogoFileName: string = !! Constants.BRAND_LOGO_FILE_NAME ? Constants.BRAND_LOGO_FILE_NAME : 'brand_logo.png';

  public get username(): string {
    return this.user?.fullname;
  }

  public get isGutachterportal(): boolean{
    return this.stammdatenService.Portalkonfiguration.portalTyp == GlobalEnumsAcePortaltyp.Begutachtung;
  }

  public get portalName(): string {
    return environment?.xFoundPortalConfig?.portalName + ` Logo`;
  }

  constructor(protected router: Router,
    protected stateService: StateService,
    protected route: ActivatedRoute,
    protected authenticationService: ExtendedAuthenticationService,
    protected stammdatenService: StammdatenService,
    public translate: TranslateService,
    protected languageService: I18nService) {
  }

  ngOnInit(): void {
    this.portalkonfiguration = this.route.snapshot.data.portalkonfiguration;

    if(this.authenticationService.CurrentUser)
      this.user = this.authenticationService.CurrentUser;

    //check for Portalconfig Mehrsprachig
    if(this.IsPortalMehrsprachig){
      this.languageService.supportedLanguages.forEach(lang => this.langsObject.push({value: lang, text: this.getLanguage(lang)}));
      this.languageFormControl.patchValue(this.getCurrentLangsObject() ?? this.langsObject[0]);
      this.languageService.language = this.languageFormControl.value.value;
    }
    else{
      //set de as language, and remove all other languages from supported languages
      let de = this.languageService.supportedLanguages.splice(this.languageService.supportedLanguages.findIndex(x => x == 'de'),1);
      this.languageService.supportedLanguages = de;
      this.languageService.language = de[0];
    }
  }

  public switchLang(lang: string) {
    this.languageService.language = lang;
  }

  public getCurrentLangsObject(): any {
    return this.langsObject.find(langObject => langObject.value == this.languageService.language);
  }

  public getLanguage(lang: string) {
    return this.languageService.getLanguageDisplayName(lang)
  }

  @ViewChild("anchor") public anchor: ElementRef;
  @ViewChild("popup", { read: ElementRef }) public popup: ElementRef;

  @HostListener("keydown", ["$event"])
  public keydown(event: any): void {
    if (event.keyCode === 27) {
      this.show = false;
    }
  }

  @HostListener("document:click", ["$event"])
  public documentClick(event: any): void {
    if (this.showUsername && !this.contains(event.target)) {
      this.show = false;
    }
  }

  public onToggle(): void {
    this.show = !this.show;
  }
  
  logout() {
    this.authenticationService.logout().subscribe(() => {
      this.router.navigate(['/authentication'], { replaceUrl: true });
    });
  }

  protected contains(target: any): boolean {
    return (
      this.anchor.nativeElement.contains(target) ||
      (this.popup ? this.popup.nativeElement.contains(target) : false)
    );
  }

  isCurrentRouteIn(route: string): boolean {
    return this.router.url.includes(route);
  }

  toggleProzessNavigation(): void {
    this.stateService.ToggleProzessNavigation();
  }

  public get IsPortalMehrsprachig ():boolean{
    if(this.portalkonfiguration.portalSprache == GlobalEnumsAcePortalsprache.Mehrsprachig){
      return true;
    }
    else 
      return false;
  }
}
